import { render, staticRenderFns } from "./LoginRecord.vue?vue&type=template&id=1c4cbecc&scoped=true"
import script from "./LoginRecord.vue?vue&type=script&lang=js"
export * from "./LoginRecord.vue?vue&type=script&lang=js"
import style0 from "./LoginRecord.vue?vue&type=style&index=0&id=1c4cbecc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4cbecc",
  null
  
)

export default component.exports